if (!customElements.get('product-item')) {
class ProductItem extends HTMLElement {
  constructor() {
    super();

    this.data = this.dataset;
    this.popupContent = document.querySelector('#quickview-modal [data-modal-content]')
    this.quickViewButtons = [...this.querySelectorAll('[data-quickview-trigger]')];
    this.compareInput = this.querySelector('.compare-input');
  }

  connectedCallback() {
    this.getQuickViewContents();
    this.quickViewButtons.forEach((btn) => {
      btn.addEventListener('click', e => this.handleQuickViewPopup(e))
    })
  }

  async getQuickViewContents() {
    const getSectionHtml = (html, selector) => {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    const url = `${window.Shopify.routes.root}products/${this.data.handle}?view=quickview`
    const productContent = await fetch(url)
    .then((response) => {
      if (response.ok) {
        return response.text();
      } else {
        return false;
        // throw new Error('Something went wrong');
      }
    })
    .catch((error) => {
      console.log(error)
    });

    if (productContent) {
      const script = document.createElement('script');
      script.classList.add(`quickview-modal-content-${this.data.id}`);
      script.setAttribute('type', 'text/template');
      script.innerHTML = getSectionHtml(productContent, '.product-main-section');

      const quickviewMarkupWrapper = document.querySelector('[data-quickview-content-markups]');
      if (quickviewMarkupWrapper) {
        quickviewMarkupWrapper.append(script);
      } else {
        document.body.append(script);
      }
    }
  }

  // Quick View Popup Events
  handleQuickViewPopup(e) {
    e.preventDefault();
    const markupContent = document.querySelector(`.quickview-modal-content-${this.data.id}`);

    if (markupContent) {
      // console.log(markupContent);
      this.popupContent.innerHTML = markupContent.innerHTML;
      this.bindModalEvents();
      this.quickViewButtons.forEach((btn) => { btn.classList.remove('loading') });
      MicroModal.show('quickview-modal');
    } else {
      this.quickViewButtons.forEach((btn) => { btn.classList.remove('loading') });
      console.log('No quickview content!');
    }
  }

  bindModalEvents() {
    site.initToolTip();
    site.initShowMore();
    MagicZoom.refresh();

    // Init PDP variant form
    const sections = new slate.Sections();
    sections.register('product', theme.Product);

    // Swym integration
    document.dispatchEvent(new CustomEvent("swym:quickview-loaded"));

    // PDP enhancement options & Free GWP
    this.handleEnhanceOptions();
    this.handleGWPOptions();

    // Modal Events;
    this.handleModalEvents();

    MagicZoom.refresh();

    const productForm = this.popupContent.querySelector('.product__form');
    if (productForm) {
      new theme.AjaxProduct(productForm);
    }
  }

  // TODO: Need to update jquery codes to vanilla js
  handleEnhanceOptions() {
    const selectCheck = () => {
      const qty = parseFloat($("#Quantity").val());
      this.updateEnhanceOptionPrice(qty);
    }

    const quantityChange = (qty) => {
      this.updateEnhanceOptionPrice(qty)
    }

    const isOutStock = parseFloat($('[data-product-select] option:selected').attr('data-inventory'));
    if (isOutStock > 0) {
      $(".main_enhance").removeClass("checkbox-disabled"); 
    } else {
      $(".main_enhance").addClass("checkbox-disabled"); 
    }

    $(document).on('change', 'input[name="pp_en"]', () => {
      const qty = parseFloat($("#Quantity").val());
      this.updateEnhanceOptionPrice(qty)
    });

    $(document).on('change', '#Quantity', (e) => {
      const qty = parseFloat($(e.currentTarget).val());
      quantityChange(qty);
    });

    $(document).on('change', '[data-single-option-selector]', (e) => {
      const $form = $(e.target).closest('form');
      const qty = parseFloat($form.find("#Quantity").val());
      quantityChange(qty);
    });

    $(document).on("click", ".enhance-small", function() {
      $(this).parent().parent().parent().find(".model-main-sec").addClass('show');
    });

    $(document).on("click", ".model-main-sec", function(e) {
      var container = $(".model-inc-sec");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $(this).removeClass('show');
      }
    });

    $(document).on("click", "#enha-modal-close", () => {
      $(".model-main-sec").removeClass('show');
    });

    $(document).on("click", ".add-this-item", function() {
      const id = $(this).attr("data-id");
      if ($(`.${id}`).prop("checked") == false) {
        $(`.${id}`).prop("checked", true);
        selectCheck();
      }
      $(this).parents('.option_enhance').addClass('enhance-border');
      $(".model-main-sec").removeClass('show');
    });
  }

  updateEnhanceOptionPrice(qty) {
    const variantPrice = parseFloat($('[data-product-select] option:selected').attr("data-price"));
    let itemPrice = variantPrice;
    let checkedItems = 0;

    $('.product-buy-box input[name="pp_en"]').each(function() {
      const isChecked = $(this).prop("checked");
      if (isChecked) {
        const enhanceOptionPrice = parseFloat($(this).next().next().next(".price_enh").attr("data-price"));
        itemPrice = itemPrice + enhanceOptionPrice;
        checkedItems++;
      }
    });

    if (checkedItems > 0) {
      itemPrice = itemPrice * parseInt(qty);
      const formatedPrice = slate.Currency.formatMoney(itemPrice, theme.formatMoney);
      $('#enhance_ppri').html(formatedPrice);
    } else {
      $('#enhance_ppri').html(slate.Currency.formatMoney(variantPrice, theme.formatMoney));
    }
  }

  handleGWPOptions() {
    const self = this
    enhanceMultipleProducts();
    enhanceVariantSelect();
    $("select[data-en-product-select]").prop("selectedIndex", 0)

    function enhanceVariantSelect() {
      var $enhanceVariantSelectors = $('[data-en-select-variant]');
      $enhanceVariantSelectors.on('change', (e) => {
        var $item = $(e.currentTarget).closest('.option_enhance');
        var variantId = $(e.currentTarget).find('option:selected').val();
        var sku = $(e.currentTarget).find('option:selected').attr('sku')
  
        $item.find('[data-en-select-variant]').val(e.currentTarget.value)
        $item.find('[data-variant-id]').val(variantId);
        $item.find('[data-item-sku]').html(sku);
      })
    }

    function enhanceMultipleProducts() {
      const $select = $('[data-en-product-select]');
  
      $select.off('change');
      $select.on('change', (e) => {
        let $wrap = $(e.currentTarget).closest('.option_enhance');
        let $modal = $(e.currentTarget).closest('.model-main-sec');

        if ($wrap.length > 0 && $modal.length == 0) {
          // If clicked inside modal select
          const modalKey = $wrap.data('modalKey');
          $modal = $(`.model-main-sec[data-key="${modalKey}"]`);
        }

        if ($wrap.length == 0 && $modal.length > 0) {
          // If clicked inside enhance option
          const key = $modal.data('key');
          $wrap = $(`.option_enhance[data-modal-key="${key}"]`);
        }

        const qty = parseFloat($("#Quantity").val());
        self.updateEnhanceOptionPrice(qty);

        if ($modal.length > 0) {
          updateContent(e.currentTarget, $modal);
        }

        if ($wrap.length > 0) {
          updateContent(e.currentTarget, $wrap);
        }

        function updateContent(_this, $target) {
          // Update Content
          var $selected = $(_this).find('option:selected');
          var productId = $selected.attr('data-product');
          var variantId = $selected.attr('data-variant');
          var img = $selected.attr('data-img');
          var modalimg = $selected.attr('data-modal-img');
          var title = $selected.attr('data-title');
          var sku = $selected.attr('data-sku');
          var url = $selected.attr('data-url');
          var reviews = $selected.attr('data-reviews');
          var price = $selected.attr('data-price');

          if (price) {
            var priceUpdated = slate.Currency.formatMoney(price, theme.settings.moneyFormat);
            $target.find('[data-product-price]').text(priceUpdated);
            $target.find('.price_enh').attr('data-price', price)
          }

          $target.find('[data-en-product-select]').val(_this.value);
          $target.find('[data-variant-id]').val(variantId);
          $target.find("[data-item-img]").attr("src", img);
          $target.find("[data-item-img-modal]").attr("src", modalimg);
          $target.find("[data-item-title]").text(title);
          $target.find("[data-item-sku]").text(sku);
          $target.find("[data-item-url]").attr("href", url);
          $target.find("[data-item-reviews]").attr('data-id', productId)
          $target.find("[data-item-reviews]").html('');
        }
      });
    }
  }

  handleModalEvents() {
    const closeButtons = [...document.querySelectorAll('.modal-quickview [data-modal-close]')];
    closeButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        MicroModal.close('quickview-modal');
      });
    });
  }
}

customElements.define('product-item', ProductItem);
}
